import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { mangaCategories, mangaList } from '@/mocks/comics';
import ComicsCard from '@/components/feature/ComicsCard';

export default function CategorySection() {
  const [activeCategory, setActiveCategory] = useState('all');
  const navigate = useNavigate();

  const filteredManga =
    activeCategory === 'all'
      ? mangaList.slice(0, 8)
      : mangaList
          .filter((m) => m.categorySlug === activeCategory)
          .slice(0, 8);

  const handleCategoryClick = (slug: string) => {
    setActiveCategory(slug);
  };

  const handleViewAll = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="category-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2
            id="category-heading"
            className="font-heading font-bold text-2xl md:text-3xl text-foreground-900"
          >
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            按类别发现你喜欢的韩漫作品
          </p>
        </div>

        <div className="flex items-center justify-center flex-wrap gap-2 mb-10">
          {mangaCategories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleCategoryClick(cat.slug)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <span className="w-4 h-4 inline-flex items-center justify-center mr-1.5">
                <i className={cat.icon}></i>
              </span>
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-6">
          {filteredManga.map((manga) => (
            <ComicsCard key={`cat-${activeCategory}-${manga.id}`} manga={manga} />
          ))}
        </div>

        {filteredManga.length === 0 && (
          <div className="text-center py-16">
            <div className="w-16 h-16 mx-auto flex items-center justify-center text-foreground-300">
              <i className="ri-emotion-sad-line text-4xl"></i>
            </div>
            <p className="text-foreground-500 mt-4">该分类暂无漫画，请浏览其他分类</p>
          </div>
        )}

        <div className="text-center mt-10">
          <button
            onClick={() => handleViewAll(activeCategory)}
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-primary-300 text-primary-500 font-medium rounded-full text-sm hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 {mangaCategories.find((c) => c.slug === activeCategory)?.name || ''} 漫画
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}